import { Theme } from 'baseui';
import StyleBreakpoint from 'common/styles/styles.breakpoint';
import stylesColors from 'common/styles/styles.colors';
import typography, { fontFamily } from 'common/styles/styles.typography';
import { themedStyled } from 'common/styles/styletron.theme';

export const styles = {
  active: {
    borderBottomColor: `${stylesColors.skyDefault} !important`,
    borderRightColor: `${stylesColors.skyDefault} !important`,
    borderTopColor: `${stylesColors.skyDefault} !important`,
    borderLeftColor: `${stylesColors.skyDefault} !important`,
    borderWidth: '1px',
    backgroundColor: 'transparent',
    // padding: '0px !important',
    margin: '0px !important',
    // paddingTop: "16px !important",
    color: `${stylesColors.inkDark} !important`,
    '-webkit-text-fill-color': `${stylesColors.inkDark} !important`,
    '::placeholder': {
      color: `${stylesColors.skyLight} !important`,
      '-webkit-text-fill-color': `${stylesColors.skyLight} !important`,
    },
  },
  reset: {
    borderBottomColor: `#EEEEEE !important`,
    borderRightColor: `#EEEEEE !important`,
    borderTopColor: `#EEEEEE !important`,
    borderLeftColor: `#EEEEEE !important`,
    borderWidth: '1px',
    backgroundColor: '#EEEEEE !important',
    borderRadius: '8px',
    color: `${stylesColors.inkDark} !important`,
    '-webkit-text-fill-color': `${stylesColors.inkDark} !important`,
    '::placeholder': {
      color: `${stylesColors.skyLight} !important`,
      '-webkit-text-fill-color': `${stylesColors.skyLight} !important`,
    },
  },
  resetInputTable: {
    borderBottomColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: 'transparent',
    borderLeftColor: 'transparent',
    backgroundColor: 'transparent',
    padding: '0px !important',
    margin: '0px !important',
    // color: `${stylesColors.inkDark} !important`,
    '-webkit-text-fill-color': `${stylesColors.inkDark} !important`,
    '::placeholder': {
      color: `${stylesColors.skyLight} !important`,
      '-webkit-text-fill-color': `${stylesColors.skyLight} !important`,
    },
  },
  disabledReset: {
    opacity: '0.5',
  },
};

export const RightEnhancerContainer = themedStyled('div', {
  marginLeft: '8px',
  display: 'flex',
  alignItems: 'center',
});

export const LabelContainer = themedStyled('div', () => {
  return {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  };
});

export const RequiredText = themedStyled('span', {
  color: 'red',
  marginTop: '-4px',
  marginLeft: '3px',
});

export const PaginationContainer = themedStyled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '8px',
  fontFamily,

  justifyContent: 'space-between',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});

export const PaginationText = themedStyled('span', {
  ...typography.body3Regular,
  color: '#9DA0A1',

  [`@media screen and (max-width: calc(${StyleBreakpoint.lg} - 1px))`]: {
    marginBottom: '16px',
  },
});

export const PaginationHighlightText = themedStyled('span', {
  color: 'black',
});

export const PaginationSectionContainer = themedStyled('div', {
  display: 'flex',
  // flex: 1,
});

export const ErrorViewContainer = themedStyled<
  'div',
  { vertical?: number },
  Theme
>('div', ({ vertical }) => ({
  display: 'flex',
  flexDirection: 'row',
  maxWidth: '100%',
  alignItems: 'center',
  cursor: 'pointer',

  ...(vertical
    ? {
        flexDirection: 'column',
      }
    : {}),
}));

export const ErrorImageContainer = themedStyled('div', {
  width: '60px',
  height: '50px',

  minWidth: '60px',
  minHeight: '50px',
});

export const ErrorImage = themedStyled('img', {
  width: '100%',
  height: '100%',
});

export const ErrorContentContainer = themedStyled<
  'div',
  { vertical?: number },
  Theme
>('div', ({ vertical }) => ({
  margin: '0px 8px',
  textAlign: 'center',

  ...(vertical
    ? {
        margin: '16px 0px',
      }
    : {}),
}));

export const ErrorActionContainer = themedStyled('div', {});

export const ErrorSpan = themedStyled('p', {
  fontSize: '12px',
  lineHeight: 1.2,
  margin: 0,
});

export const RefreshContainer = themedStyled('div', {
  cursor: 'pointer',
});

export const CustomFormControlWrapper = themedStyled('div', {});

export const RawInput = themedStyled('input', {
  border: 'none',
  padding: '0px',
  width: '100%',
  backgroundColor: 'transparent',
});

export const RawButton = themedStyled('button', {
  margin: '5px',
  backgroundColor: 'white',
  color: stylesColors.primaryDefault,
  border: `2px solid ${stylesColors.primaryDefault}`,
  borderRadius: '99px',
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold',
  cursor: 'pointer',
});
